// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const PickerRow = styled.div`
  display: flex;
  align-items: center;
  /* Lets the row wrap to a 2nd line instead of squeezing PickerText and the
     fixed-width selects below a usable size when this row runs out of
     horizontal room (e.g. under browser zoom, WCAG 1.4.4). */
  flex-wrap: wrap;
  row-gap: 0.5rem;
`;

export const PickerSpacedRow = styled(PickerRow)`
  margin-top: 1rem;
`;

export const PickerText = styled.span`
  font-weight: bold;
  /* min-width: 0, not a fixed 48px floor, plus white-space: nowrap to
     complete the ellipsis trio below — without both, a long schedule
     phrase (translated strings can run much longer than English) can't
     shrink far enough to show "…" and instead gets visually squeezed at a
     fixed 48px under browser zoom (WCAG 1.4.4). */
  min-width: 0;
  white-space: nowrap;
  margin-right: 12px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const ScheduleDescriptionContainer = styled.div`
  margin-top: 1rem;
  color: var(--mb-color-text-secondary);
`;
